/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { ProductSearchResult, Product, ProductWarehouseInventoryInformation, ProductPrice } from '@msdyn365-commerce/retail-proxy';

import { searchByCategoryAsync, getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

import { getTelemetryObject, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';

import classnames from 'classnames';
import { getProductListFromCategory } from './component/ecomm-product-list.component';
import { ICartDataSet, IProductListMainComponentState } from './component/components-interfaces-definition';

import { IEcommProductListData } from './ecomm-product-list.data';
import { IEcommProductListProps } from './ecomm-product-list.props.autogenerated';
import { config } from '@fullcalendar/react';

/**
 *
 * EcommProductList component
 * @extends {React.PureComponent<IEcommProductListProps<IEcommProductListData>>}
 */
class EcommProductList extends React.PureComponent<IEcommProductListProps<IEcommProductListData>, IProductListMainComponentState> {
  private telemetryContent: ITelemetryContent;

  constructor(props: IEcommProductListProps<IEcommProductListData>) {
    super(props);

    this.state = {
      errorState: {
        configureErrors: {}
      },
      productResult: [],
      simpleProductResult: [],
      productsAvailability: {},
      productsIds: [],
      productPriceArr: [],
      categoryIds: []
    };

    this.telemetryContent = getTelemetryObject(props.context.request.telemetryPageName!, props.friendlyName, props.telemetry);
  }

  public render(): JSX.Element | null {
    const { slots: { mediaGallery }, data: { filteredCategories, hierarchy, cart }, config: { className = '' }, context } = this.props;
    
    const categories: string[] = filteredCategories.result ? filteredCategories.result.filteredCategories : [];

    getProductListFromCategory(this.props, categories)
    .then((resultObj: ICartDataSet) => {
      let productList: Product[]  = [];
      let productsAvailability: ProductWarehouseInventoryInformation | undefined = {};
      let productsIds: number[] | undefined = [];
      let productPriceList: ProductPrice[] | undefined = [];

      if (resultObj.selectedProducts) {
        productList = resultObj.selectedProducts;
        productsAvailability = resultObj.productsAvailability;
        productPriceList = resultObj.activePrices;
        productsIds = resultObj.productIds;
      }

      if (JSON.stringify(productList) !== JSON.stringify(this.state['productResult'])) {
        this.setState({ productResult: productList, productsAvailability: productsAvailability, productsIds: productsIds, productPriceArr: productPriceList, categoryIds: resultObj.categoryIds });
      }
    }).catch(error => {
      console.log('[product-list] error', error);
      
      this.setState({ productResult: [], simpleProductResult: [], productsAvailability: {}, productsIds: [], productPriceArr: [] });
    });

    if (this.state.categoryIds && this.state.categoryIds.length > 0) {
      this.state.categoryIds.map(id => {
        searchByCategoryAsync({ callerContext: context.actionContext }, context.request.apiSettings.channelId, context.request.apiSettings.catalogId, id).then(result => {
          if (result && result.length > 0) {
            result.sort((a: ProductSearchResult, b: ProductSearchResult) =>  ((a.DisplayOrder!) < (b.DisplayOrder!) ? -1 : 1));

            const productIds: number[] = [];
  
            result.map(item => productIds.push(item.RecordId));
  
            getByIdsAsync({ callerContext: context.actionContext }, context.request.apiSettings.channelId, productIds)
            .then(ret => this.setState({ simpleProductResult: ret }) );
          }
        });
      });
    }

    let ProductListViewProps = {
      ...this.props,
      filteredCategories: filteredCategories,
      hierarchy: hierarchy,
      cart: cart,
      telemetryContent: this.telemetryContent,
      productsList: this.state['productResult'],
      simpleProductList: this.state['simpleProductResult'],
      productsAvailability: this.state['productsAvailability'],
      productsIds: this.state['productsIds'],
      productPriceList: this.state['productPriceArr'],
      categoryIds: this.state.categoryIds,
      mediaGallery: mediaGallery && mediaGallery.length > 0 ? mediaGallery[0] : undefined,
      ModuleProps: {
        moduleProps: this.props,
        className: classnames('ms-buybox', className)
      },
      ProductInfoContainerProps: {
        className: 'ms-buybox__content'
      },
      MediaGalleryContainerProps: {
        className: 'ms-buybox__media-gallery'
      },
      unavailableText: config.unavailableText ? config.unavailableText : ''
    };

    return this.props.renderView(ProductListViewProps);
  }
}

export default EcommProductList;